export default {"src":"/_next/static/media/carSidebarIcon.b498a300.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};